import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";
import { Heading4 } from "styles/elements/Headings";
import { CssButton, CssFlex, CssGrid, CssIcon } from "styles/helpers/layout";

export const StyledNewGroupCard = styled(CssFlex)<Props>`
  gap: 1rem;
  padding: 3rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  border: 1px dashed ${(props: Props) => props.theme.palette.secondary._900};
  border-radius: 1rem;

  &:hover {
    cursor: pointer;
    border-color: ${(props: Props) => props.theme.palette.secondary.brand};
    transition: all 0.2s ease-in-out;
    box-shadow: 0px 5px 10px 0px rgba(84, 84, 84, 0.2);
  }
`;

export const StyledGroupCard = styled(CssGrid)<Props>`
  border-radius: 1rem;
  grid-template-rows: 1fr auto;
  gap: 1rem;
  padding: 1rem;
  border: solid 1px;
  border-color: ${(props: Props) => props.theme.palette.neutral._900};
  background: ${(props: Props) => props.theme.palette.neutral.white};

  &:hover {
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    box-shadow: 0px 5px 10px 0px rgba(84, 84, 84, 0.2);
  }

  ${Heading4} {
    font-size: ${(props: Props) => props.theme.font.size._18};
  }

  hr {
    border: 0;
    margin: 0;
    width: 100%;
    height: 1px;
    background: ${(props: Props) => props.theme.palette.neutral._800};
  }

  ${CssIcon} {
    color: ${(props: Props) => props.theme.palette.secondary.brand};
  }

  ${CssButton} {
    border-radius: 8px;
    padding: 0.3rem 1.5rem;
    font-weight: 400;
  }
`;
